// constant.js
export const productPlans = {
    product1: [
      { id: 1, name: "Plan 1", currentPrice: "@ ₹420", originalPrice: "₹1000/day", amount: 420 },
      { id: 2, name: "Plan 2", currentPrice: "@ ₹210", originalPrice: "₹500/day", amount: 210 },
    ],
    product2: [
      { id: 1, name: "Plan A", currentPrice: "@ ₹210", originalPrice: "₹500/day" },
      { id: 2, name: "Plan B", currentPrice: "@ ₹210", originalPrice: "₹500/day" },
    ],
    // Add more products and their plans here
  };
  